export class Constants {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  static usageAEM: any = {
    ELITE: 'ELITE',
    MEMBER: 'MEMBER',
  };
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  static usage: any = {
    FREE: 'FREE',
    PURCHASED: 'PURCHASED',
    ELITE: 'ELITE',
    MEMBER: 'MEMBER',
    ACCESS: 'ACCESS',
  };
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  static plan: any = {
    PLAN1: 'PLAN1',
    PLAN2: 'PLAN2',
  };
}

export const INTERNET_BAR_INITIAL_STATE = {
  title: '',
  welcomeText: '',
  description: '',
  isConnectState: false,
  connectUpgradeBtn: '',
  signInButton: {
    signInButtonLink: '',
    signInButtonLabel: '',
    signInButtonLinkInNewTab: '',
  },
  joinNowButton: {
    joinButtonLabel: '',
    joinButtonLink: '',
    joinButtonLinkInNewTab: '',
  },
  termsAndConditions: '',
  signInText: '',
  noLoginInterfaceModal: false,
  showLoginModal: false,
  loginModal: {
    default: false,
    separatorLabel: false,
    userAccessCodeLabel: false,
    requestAccessCodeLabel: false,
    errorMessage: false,
    connectNowLabel: false,
  },
  showAccessModal: false,
  accessModal: {
    default: false,
    acErrorMessage: false,
  },
  showReqAccessModal: false,
  reqAccessModal: {
    default: false,
    racErrorMessage: false,
  },
  showUpgradeGenErr: false,
  showUpgradeLRErr: false,
  showUpgradeMaxErr: false,
  showUpgradeNoCCErr: false,
  showUpgradePMSErr: false,
  showUpgradeSuccessNAInfo: false,
  showUpgradeSuccessMAXInfo: false,
  showPricingModal: false,
  showUpgradeModal: false,
};

export const LOYALTY_ENABLED_ZONES = ['GUEST', 'PUBLIC', 'LOBBY'];

export const DEFAULT_LOYALTY_OBJ = {
  mr_enrolled: false,
  mr_enrollment_source: '',
};

export const DEFAULT_LOCALE = 'en-US';

export const LOCALE_SUPPORT_NO_SPACE_C_PRICE_MODAL = ['ko-kr'];

export const INTERNETBAR_PRICING_ZONE_OPTIONS = {
  guest: 'guest_room_conn_pricing',
  public: 'public_area_room_conn_pricing',
  conference: 'meeting_area_room_conn_pricing',
};

export const INTERNETBAR_PRICING_TIER_OPTIONS = {
  tierOne: 'Tier1',
  tierTwo: 'Tier2',
};

export const NEW_AGE_UX = {
  conservativeWithIncentive: 'conservative-with-incentive',
  conservativeWithoutIncentive: 'conservative-without-incentive',
  marketingWithIncentive: 'marketing-with-incentive',
  marketingWithoutIncentive: 'marketing-without-incentive',
};

export const INTERNETBAR_MODAL_ICON = ['WE_CHAT'];

export const MINI_APP_LINK = `weixin://dl/business/?appid=__WE_CHAT_APP_ID__&path=pages/index/main&env_version=release&query=scid%3D__MARSHA___WIFI%26eSrc%3D__ENROLLMENT_SRC_CODE__`;

export const LOYALTY_URL = '/loyalty/createAccount/createAccountPage1.mi';

export const WE_CHAT_APP_ID = 'wx024b5aa2f22f2314';
